// extracted by mini-css-extract-plugin
export default {"productdiv":"Box_productdiv__i7Rz9","addmoreleg":"Box_addmoreleg__pwaHg","delete_box":"Box_delete_box__B27k6"};